import React from 'react';


export const sidePaddingNormal = (theme) => ({
  paddingLeft: '2em',
  paddingRight: '2em',
  [theme.breakpoints.up('md')]: {
    paddingLeft: '6em',
    paddingRight: '6em',
  }
});

export const verticalPaddingNormal = (theme) => ({
  paddingTop: '4em',
  paddingBottom: '4em',
  [theme.breakpoints.up('md')]: {
    paddingTop: '12em',
    paddingBottom: '12em',
  }
});

export const verticalPaddingSmall = (theme) => ({
  paddingTop: '3em',
  paddingBottom: '3em',
  [theme.breakpoints.up('md')]: {
    paddingTop: '7em',
    paddingBottom: '7em',
  }
});



// WEBPACK FOOTER //
// ./src/styles/layouts.js